import React from "react";
import {useTranslation} from "react-i18next";

export interface TourFormValues {
    destination: string;
    dateFrom: string;   // YYYY-MM-DD
    timeFrom: string;   // HH:mm
    dateTo: string;
    timeTo: string;
}

interface Props {
    values: TourFormValues;
    disableFields: boolean;
    onChange: (field: keyof TourFormValues, value: string) => void;
}

export default function TourEditForm({values, disableFields, onChange}: Props) {
    const {t} = useTranslation();

    return (
        <>
            {/* Ziel */}
            <div className="form-group">
                <label>{t("tours.fields.destination")}</label>
                <input
                    type="text"
                    value={values.destination}
                    onChange={e => onChange("destination", e.target.value)}
                    className="form-input"
                    disabled={disableFields}
                    required
                />
            </div>

            {/* Startzeit */}
            <div className="form-group">
                <label>{t("tours.fields.validFrom")}</label>

                <div className="form-row split-75-25">
                    <input
                        type="date"
                        value={values.dateFrom}
                        onChange={e => onChange("dateFrom", e.target.value)}
                        className="form-input"
                        disabled={disableFields}
                        required
                    />

                    <input
                        type="time"
                        value={values.timeFrom}
                        onChange={e => onChange("timeFrom", e.target.value)}
                        className="form-input"
                        disabled={disableFields}
                        required
                    />
                </div>
            </div>

            {/* Endzeit */}
            <div className="form-group">
                <label>{t("tours.fields.validTo")}</label>

                <div className="form-row split-75-25">
                    <input
                        type="date"
                        value={values.dateTo}
                        onChange={e => onChange("dateTo", e.target.value)}
                        className="form-input"
                        disabled={disableFields}
                        required
                    />

                    <input
                        type="time"
                        value={values.timeTo}
                        onChange={e => onChange("timeTo", e.target.value)}
                        className="form-input"
                        disabled={disableFields}
                        required
                    />
                </div>
            </div>
        </>
    );
}